import { auth0ApiClient } from './auth0ApiClient'
import type { IAuthorSnapshot } from '@/types/feed'

export interface CuratedItemComment {
  id: string
  curatedItemId: string
  authorId: string
  author: IAuthorSnapshot
  content: string
  createdAt: string
  updatedAt: string
}

export interface CuratedItemCommentPage {
  items: CuratedItemComment[]
  hasMore: boolean
  nextCursor?: string
}

interface PaginatedEnvelope<T> {
  success: boolean
  data: T[]
  pagination: {
    hasMore: boolean
    nextCursor?: string
  }
}

class CuratedItemCommentService {
  private readonly baseUrl = '/feed/curated'

  createComment(curatedItemId: string, content: string): Promise<CuratedItemComment> {
    return auth0ApiClient.post<CuratedItemComment>(`${this.baseUrl}/${curatedItemId}/comments`, { content })
  }

  deleteComment(commentId: string): Promise<void> {
    return auth0ApiClient.delete<void>(`${this.baseUrl}/comments/${commentId}`)
  }

  async getComments(
    curatedItemId: string,
    params: { cursor?: string; limit?: number } = {}
  ): Promise<CuratedItemCommentPage> {
    const usp = new URLSearchParams()
    if (params.cursor) usp.append('cursor', params.cursor)
    if (params.limit) usp.append('limit', String(params.limit))
    const query = usp.toString()

    const env = await auth0ApiClient.getEnvelope<PaginatedEnvelope<CuratedItemComment>>(
      `${this.baseUrl}/${curatedItemId}/comments${query ? `?${query}` : ''}`
    )
    return {
      items: env.data,
      hasMore: env.pagination.hasMore,
      ...(env.pagination.nextCursor && { nextCursor: env.pagination.nextCursor })
    }
  }
}

export const curatedItemCommentService = new CuratedItemCommentService()
